export const AUTHENTICATED = 'AUTHENTICATED'
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const RESET_PASSWORD_REQUIRED = 'RESET_PASSWORD_REQUIRED'
export const PASSWORD_RESET = 'PASSWORD_RESET'
export const CONFIRM_REGISTRATION_REQUIRED = 'CONFIRM_REGISTRATION_REQUIRED'
